var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiperItem",style:({width:_vm.itemW+'px'}),on:{"scroll":_vm.swiperScroll}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }